import * as React from 'react'
import { BaseIcon } from './'

export const Plus = (props: React.ComponentProps<typeof BaseIcon>) => (
  <BaseIcon {...props}>
    <rect x="5" y="1" width="2" height="10" fill="currentcolor" />
    <rect y="5" x="1" height="2" width="10" fill="currentcolor" />
  </BaseIcon>
)
